import { ChangeDetectorRef, Component, HostBinding, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { EaChartAbstractComponent } from '../ea-chart-abstract/ea-chart-abstract.component';
import { donutSweepMask } from './donut-sweep-mask';

const RENDERED_CHART_HEIGHT = 220;
const PIE_SLICED_OFFSET = 10;

@Component({
    selector: 'ea-circle-chart',
    templateUrl: './ea-circle-chart.component.html',
    styleUrls: ['./ea-circle-chart.component.scss'],
    standalone: false
})
export class EaCircleChartComponent
  extends EaChartAbstractComponent<any>
  implements OnInit
{
  @Input() innerWidth: number;
  @Input() isRedirect: boolean = false;
  @Input() unity: string = '';
  @HostBinding('class.entrance') @Input() animated: boolean = false;
  @HostBinding('class.placeholder') @Input() placeholder: boolean = false;

  get placeholderRingSize(): number {
    const plotSize = Math.min(
      Number(this.width) || RENDERED_CHART_HEIGHT,
      RENDERED_CHART_HEIGHT,
    );
    return plotSize - 2 * PIE_SLICED_OFFSET;
  }

  get placeholderRingOffset(): number {
    return (RENDERED_CHART_HEIGHT - this.placeholderRingSize) / 2;
  }

  get sweepMask(): string | null {
    if (!this.animated) {
      return null;
    }
    const points = this._options?.series?.[0]?.data ?? [];
    return donutSweepMask(
      points.map(point => (typeof point === 'number' ? point : point?.y)),
      RENDERED_CHART_HEIGHT / 2,
    );
  }

  constructor(
    protected translate: TranslateService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translate, changeDetectorRef);
  }

  ngOnInit(): void {
    this._options = {
      ..._.merge(this._options, {
        chart: {
          backgroundColor: 'transparent',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          spacingTop: 0,
          spacingBottom: 0,
          type: 'pie',
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          formatter: function () {
            return (
              '<span style="color:' +
              this.point.color +
              '">●</span> ' +
              this.point.name +
              ': <b>' +
              this.y.toLocaleString('fr-FR', {
                useGrouping: true,
                minimumFractionDigits: 2,
              }) +
              (this.point.unityTooltip ? this.point.unityTooltip : ' €') +
              '</b>'
            );
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            center: ['50%', '50%'],
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.percentage:.0f} %</b>',
              borderWidth: 0,
              distance: -15,
              // distance: -20,
              style: {
                textOutline: 'none',
                fontWeight: 600,
                fontSize: 14,
              },
              color: 'white',
            },
            innerSize: this.innerWidth ? `${this.innerWidth}%` : '55%',
            borderWidth: 0,
          },
        },
        series: [
          {
            innerSize: this.innerWidth ? `${this.innerWidth}%` : '65%',
            data: this.series || this._options.series,
          },
        ],
      }),
    };
  }
}
